import { gql } from '@apollo/client';

export const SIGNUP = gql`
    mutation addUser($userInput: UserInput!){
        addUser(userInput: $userInput) {
            _id
        }
    }
`;
